export default "__VITE_ASSET__x4FgiUUD__";